import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEinwertIconSmall = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 43 25",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#0A1866",
			d: "m28.706.5-4.461 15.448-2.88 8.123H27.3L34.795.5zm-14.31 0-4.02 15.448L6 .5H0l7.386 23.57h6l2.338-8.955.307-1.178 1.312-5.025 2.163-8.35z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#17AD86",
			d: "M33.5 24.5v-6.676l4.326-2.602 4.49 2.602V24.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0A1866",
			d: "m14.871.598 2.162 8.352 1.312 5.024.308 1.178 2.337 8.956h6L24 15.985 19.98.537z",
			opacity: .7
		})
	]
});
export default SvgEinwertIconSmall;
